import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // load translations -> from /public/locales
  .use(Backend)
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    preload: ['en'],
    fallbackLng: 'en', // use en if detected lng is not available
    supportedLngs: ['en'],
    debug: process.env.NODE_ENV !== 'production',
    keySeparator: false,
    ns: ['common', 'inventory'],
    defaultNS: 'common',
    backend: {
      loadPath: '/public/locales/{{lng}}/{{ns}}.json',
      requestOptions: {
        cache: 'no-cache',
      },
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
